'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive('tfSectionTitle', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    transclude: true,
    template: "\n            <div class=\"tf-section-title\">\n                <div class=\"line-around line-before\"></div>\n                <div class=\"content\">\n                    <h3 ng-transclude></h3>\n                </div>\n                <div class=\"line-around line-after\"></div>\n            </div>\n        "
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/tf-form/tf-section-title.js
// module id = 3014
// module chunks = 13